/**
 * What?: This file implements the logout except for clearing the current cart state data.
 * Why?: For use case when the guest user tokens expired and new tokens are generated,
 * we don't want to clear the existing guest cart upon new anonymous tokens generation.
 */

import { AccessToken, ApiRole, Auth, Tokens, UserInfo } from 'ordercloud-javascript-sdk';
import { clearProductList } from '../ocProductList';
import { createOcAsyncThunk, OcThrottle } from '../ocReduxHelpers';
import { clearUser, getUser } from '../ocUser';
// import { clearCurrentOrder } from '../ocCurrentOrder';
import { cleanProductCache } from '../ocProductCache';
import { resetWishlistData } from '../wishlist';

const logoutThrottle: OcThrottle = {
  location: 'ocAuth',
  property: 'loading',
};

const shiftToAnonymous = createOcAsyncThunk<AccessToken | undefined>(
  'ocAuth/shiftToAnonymous',
  async (_, thunkAPI) => {
    const { ocConfig } = thunkAPI.getState();
    if (!ocConfig?.value) {
      throw new Error('OrderCloud Provider was not properly configured');
    }

    thunkAPI.dispatch(resetWishlistData());
    thunkAPI.dispatch(clearUser());
    thunkAPI.dispatch(clearProductList());
    thunkAPI.dispatch(cleanProductCache());
    // thunkAPI.dispatch(clearCurrentOrder()); // Commenting this as we don't want any miscellaneous behavior when default buyer access token is expired.

    Tokens.RemoveAccessToken();
    Tokens.RemoveRefreshToken();

    const response = await Auth.Anonymous(
      ocConfig?.value.clientId,
      ocConfig?.value.scope as ApiRole[]
    );
    Tokens.SetAccessToken(response.access_token);
    Tokens.SetRefreshToken(response.refresh_token);

    const { identity_token } = await UserInfo.GetToken();
    Tokens.SetIdentityToken(identity_token);

    thunkAPI.dispatch(getUser());
    return response;
  },
  logoutThrottle
);

export default shiftToAnonymous;
